export interface SidebarController {
  panelId: string;
  open: () => void;
  close: () => void;
  toggle: () => void;
  isOpen: () => boolean;
}

export const SIDEBAR_STATE_CHANGE_EVENT = "shell-sidebar-state-changed";

declare global {
  interface Window {
    __SHELL_SIDEBAR_CONTROLLER__?: SidebarController;
  }
}

export const getSidebarController = (): SidebarController | undefined => {
  if (typeof window === "undefined") {
    return undefined;
  }

  return window.__SHELL_SIDEBAR_CONTROLLER__;
};

export const notifySidebarControllerStateChange = (): void => {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(new CustomEvent(SIDEBAR_STATE_CHANGE_EVENT));
};

export const registerSidebarController = (
  controller: SidebarController,
): SidebarController => {
  if (typeof window !== "undefined") {
    window.__SHELL_SIDEBAR_CONTROLLER__ = controller;
    notifySidebarControllerStateChange();
  }

  return controller;
};

export const unregisterSidebarController = (
  controller?: SidebarController,
): void => {
  if (typeof window === "undefined") {
    return;
  }

  if (!controller || window.__SHELL_SIDEBAR_CONTROLLER__ === controller) {
    delete window.__SHELL_SIDEBAR_CONTROLLER__;
    notifySidebarControllerStateChange();
  }
};
